import { Control, FieldValues, Path, useController } from "react-hook-form";

import { Switch } from "#shared/view/components/Switch";

type Props<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  control: Control<T>;
  disabled?: boolean;
};

export const SwitchController = <T extends FieldValues>({
  name,
  label,
  control,
  disabled,
  ...props
}: Props<T>) => {
  const { field } = useController({ name, control });
  return (
    <Switch
      label={label}
      onChange={field.onChange}
      style={{ marginTop: 12 }}
      checked={field.value}
      disabled={disabled}
      {...props}
    />
  );
};
